import React from "react";
import { SVGIconProps } from "./SVGIconProps";
function Close(props: SVGIconProps) {
  const { width = 16, height = 16, fillColor = "#7A869A", onClick } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M12.6671 3.33325L3.33374 12.6666M3.33374 3.33325L12.6671 12.6666"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default Close;
